/**
 * CodeDTO to interact with API
 */
export class CodeDTO {
  /**
   * @constructor
   */
  constructor(public serial: string, public code: string) {}
}
